import { Lookup } from './lookup.model';
import { MeasurementModeEnum } from '../enums/measurementMode.enum';
import { AveragingTypeEnum } from "../enums/averagingType.enum";

export class Parameter {
    id: string;
    analyteName: string;
    parameterType?: number;
    type?: number;
    healthAdvisory?: string;
    specificRecommendations?: string;
    sampleTypeId?: number;
    isNotificationOnly?: boolean;
    measurementMode?: MeasurementModeEnum;
    averagingType?: AveragingTypeEnum;
    averagingTimeSeconds?: number;
    organizationLevelId?: string;
    thresholds?: ParameterThreshold[];
}

export interface ParameterThreshold {
  id?: string;
  parameterId?: string;
  label: string;
  minValue: number;
  maxValue: number | null;
  colorHex: string;
  sortOrder: number;
  noUpperBound?: boolean;
  isNotificationOnly?: boolean;
}

export interface ThresholdLegendItem {
  colorHex: string;
  label: string;
}

export class ParameterPercentage{
    isSelected: boolean;
    parameterId: string;
    parameterName?: string;
    parameterPercentage: number;
    measurementMode?: MeasurementModeEnum;
}

export class ParameterLookup extends Lookup {
  override id: string;
  parameterType: number;
  isNotificationOnly?: boolean;
  measurementMode: MeasurementModeEnum;
}

export interface ParameterApiResponse {
  id?: string;
  name?: string;
  analyteName?: string;
  parameterType?: number | string;
  type?: string;
  healthAdvisory?: string;
  specificRecommendations?: string;
  averagingType?: AveragingTypeEnum;
  averagingTimeSeconds?: number;
  isNotificationOnly?: boolean;
  measurementMode?: MeasurementModeEnum;
  organizationLevelId?: string;
  sampleTypeId?: number;
  thresholds?: Array<Record<string, unknown>>;
}

export interface ParameterListApiResponse {
  data: ParameterApiResponse[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface ParameterListResponse {
  data: Parameter[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface LinkedSensorAssignment {
  id: string;
  sensorName: string;
  location?: string;
  status?: string;
}

export interface ThresholdBand {
  id?: string;
  key: string;
  label: string;
  minValue: number;
  maxValue: number | null;
  colorHex: string;
  sortOrder: number;
  noUpperBound: boolean;
}

